import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppConsts } from '@shared/AppConsts';

@Injectable({
  providedIn: 'root'
})
export class SmartTruckMonitoringService {

  appInsights: ApplicationInsights;
  constructor() {
    this.startMonitoring();
  }

  private static readonly isApplicationInsightsEnabled: () => boolean = () => !!AppConsts.appInsightsInstrumentationKey;

  startMonitoring() {

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      const keyValue = AppConsts.appInsightsInstrumentationKey;
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: keyValue,
          enableAutoRouteTracking: true // log all route changes
        }
      });

      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }

  logPageView(name?: string, url?: string) { // call manually

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      this.appInsights.trackPageView({
        name: name,
        uri: url
      });
    }
  }

  logEvent(name: string, properties?: { [key: string]: any }) {

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      this.appInsights.trackEvent({ name: name }, properties);
    }
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      this.appInsights.trackMetric({ name: name, average: average }, properties);
    }
  }

  logException(exception: Error, severityLevel?: number) {
    console.error(exception);

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    console.log(message);

    if (SmartTruckMonitoringService.isApplicationInsightsEnabled()) {
      this.appInsights.trackTrace({ message: message }, properties);
    }
  }

}
